module.exports = __webpack_public_path__ + "static/media/service4.44e0efb9.svg";